import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import { mcClose } from '@mc/react-ui-icons';

import * as Classes from '../common/classes';
import {
  ToastTransitionPhase,
  TOAST_TRANSITION_DURATION_MS,
} from './ToasterImplementation';
import { Button } from '../button/Button';
import { Icon } from '../icon/Icon';

import type { ToastInfo } from './ToasterImplementation';

/** @deprecated */
type DeprecatedNormalIntent = 'normal';

export type ToastIntent =
  | DeprecatedNormalIntent
  | 'default'
  | 'info'
  | 'success'
  | 'warning'
  | 'danger';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  toast: ToastInfo;
  onClose: () => unknown;
}

export const Toast: React.FC<Props> = ({
  toast,
  className: passedClassName,
  onClose,
  ...restProps
}) => {
  const [manualFadeOut, setManualFadeOut] = useState<boolean>(false);
  const className = classNames(
    Classes.TOAST,
    {
      [`${Classes.TOAST}--${toast.intent}`]: toast.intent !== 'default',
      [Classes.TOAST_FADE_IN]:
        !manualFadeOut &&
        toast.transitionPhase === ToastTransitionPhase.FADE_IN,
      [Classes.TOAST_FADE_OUT]:
        manualFadeOut ||
        toast.transitionPhase === ToastTransitionPhase.FADE_OUT,
    },
    passedClassName
  );

  const closeHandler = useCallback(() => {
    setManualFadeOut(true);
    setTimeout(() => {
      onClose();
    }, TOAST_TRANSITION_DURATION_MS);
  }, [onClose]);

  return (
    <div className={className} {...restProps}>
      {toast.icon ? (
        <span className={Classes.TOAST_ICON}>{toast.icon}</span>
      ) : null}
      <div className={Classes.TOAST_BODY}>{toast.message ?? null}</div>
      <Button
        noFocus
        disableStopPropagation
        style="link"
        inverse={toast.intent !== 'default' && toast.intent !== 'normal'}
        icon={<Icon fixedWidth icon={mcClose} />}
        onClick={closeHandler}
      />
    </div>
  );
};
